import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  state: {
    loadedPosts: [],
    loadedPages: 0,
    totalPages: 2,
    feedPostId: null
  },
  mutations: {
    updateLoadedPosts(state, newPosts) {
      state.loadedPosts = state.loadedPosts.concat(newPosts);
    },
    incrementLoadedPages(state, value = 0) {
      state.loadedPages = state.loadedPages + value;
    },
    updateTotalPages(state, totalPages) {
      state.totalPages = totalPages;
    },
    setFeedPostId(state, postId) {
      state.feedPostId = postId;
    }
  },
  actions: {
    loadMorePosts({ commit, state }, itemsPerPage) {
      if (state.loadedPages >= state.totalPages) {
        return;
      }
      axios
        .get(
          `https://archives.akhilkrishnang.com/wp-json/wp/v2/posts?_embed&page=${state.loadedPages +
            1}&per_page=${itemsPerPage}`
        )
        .then(response => {
          if (response.headers && response.headers["x-wp-totalpages"]) {
            commit("updateTotalPages", response.headers["x-wp-totalpages"]);
          }
          if (response.data) {
            commit(
              "updateLoadedPosts",
              response.data.reduce(pickRelevantDetails, [])
            );
          }
        })
        .catch(error => console.log(error));
      commit("incrementLoadedPages", 1);

      //Function used to take only needed information from wp-api response
      function pickRelevantDetails(items, dataItem) {
        let postThumbnail, feedSize, feedSizeLarge;
        if (dataItem._embedded["wp:featuredmedia"]) {
          postThumbnail =
            dataItem._embedded["wp:featuredmedia"][0].media_details.sizes[
              "post-thumbnail"
            ];
          feedSize =
            dataItem._embedded["wp:featuredmedia"][0].media_details.sizes[
              "moon-third-size"
            ];
          feedSizeLarge =
            dataItem._embedded["wp:featuredmedia"][0].media_details.sizes[
              "medium_large"
            ];
          if (feedSize.width < 500) {
            //Not enough for large devices
            feedSize = feedSizeLarge;
          }
        }
        if (postThumbnail !== undefined) {
          let itemDetails = {
            id: dataItem.id,
            slug: dataItem.slug,
            format: dataItem.format,
            gallery: {
              url: postThumbnail.source_url,
              width: postThumbnail.width,
              height: postThumbnail.height
            },
            feed: {
              url: feedSize.source_url,
              width: feedSize.width,
              height: feedSize.height,
              title: dataItem.title.rendered || "",
              caption: dataItem.excerpt.rendered || ""
            }
          };
          if (itemDetails.format === "gallery") {
            itemDetails.galleryPhotos = dataItem.acf["gallery_photos"].map(
              photo => {
                return {
                  id: photo.id,
                  thumbnail: {
                    url: photo.sizes["post-thumbnail"],
                    width: photo.sizes["post-thumbnail-width"],
                    height: photo.sizes["post-thumbnail-height"]
                  },
                  display: {
                    url:
                      photo.sizes["moon-third-size-width"] > 500
                        ? photo.sizes["moon-third-size"]
                        : photo.sizes["medium_large"],
                    width: photo.sizes["moon-third-size-width"],
                    height: photo.sizes["moon-third-size-height"]
                  }
                };
              }
            );
          }
          items.push(itemDetails);
        }
        return items;
      }
    }
  },
  modules: {}
});
